"use client"

import { Routes, Route, Navigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux" // Import useDispatch
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import theme from "./theme"
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"
import DashboardPage from "./pages/DashboardPage"
import ProfilePage from "./pages/ProfilePage"
import UsersPage from "./pages/UsersPage"
import LocationsPage from "./pages/LocationsPage"
import CitiesPage from "./pages/CitiesPage"
import NonWhatsappPage from "./pages/NonWhatsappPage"
import WhiteListingPage from "./pages/WhiteListingPage"
import CampaignConfigPage from "./pages/CampaignConfigPage"
import TermsPage from "./pages/TermsPage"
import AdminTermsPage from "./pages/AdminTermsPage"
import AdminStaffPage from "./pages/AdminStaffPage"
import CreditManagementPage from "./pages/CreditManagementPage"
import SendCampaignPage from "./pages/SendCampaignPage"
import ButtonCampaignPage from "./pages/ButtonCampaignPage"
import PendingCampaignPage from "./pages/PendingCampaignPage"
import MyCampaignsPage from "./pages/MyCampaignsPage"
import ProtectedRoute from "./components/ProtectedRoute"
import AdminRoute from "./components/AdminRoute"
import AdminResellerRoute from "./components/AdminResellerRoute"
import TransactionManagementPage from "./pages/TransactionManagementPage"
import { useEffect } from "react" // Import useEffect
import { fetchLoggedInUserStatus } from "./slices/authSlice" // Import the new thunk

function App() {
  const { userInfo } = useSelector((state) => state.auth)
  const dispatch = useDispatch() // Initialize useDispatch

  useEffect(() => {
    // Check user status on component mount if user is logged in
    if (userInfo) {
      dispatch(fetchLoggedInUserStatus())
    }
  }, [userInfo, dispatch]) // Re-run if userInfo or dispatch changes

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Removed the Router component since it's already in index.js */}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route
          path="/transactions"
          element={

            <TransactionManagementPage />

          }
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/send-campaign"
          element={
            <ProtectedRoute>
              <SendCampaignPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/button-campaign"
          element={
            <ProtectedRoute>
              <ButtonCampaignPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-campaigns"
          element={
            <ProtectedRoute>
              <MyCampaignsPage />
            </ProtectedRoute>
          }
        />

        {/* Admin & Reseller Routes */}
        <Route
          path="/users"
          element={
            <AdminResellerRoute>
              <UsersPage />
            </AdminResellerRoute>
          }
        />
        <Route
          path="/credits/:userId"
          element={
            <AdminResellerRoute>
              <CreditManagementPage />
            </AdminResellerRoute>
          }
        />

        {/* Admin Only Routes */}
        <Route
          path="/locations"
          element={
            <AdminRoute>
              <LocationsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/pending-campaign"
          element={
            <AdminRoute>
              <PendingCampaignPage />
            </AdminRoute>
          }
        />
        <Route
          path="/locations/:stateId/cities"
          element={
            <AdminRoute>
              <CitiesPage />
            </AdminRoute>
          }
        />
        <Route
          path="/non-whatsapp"
          element={
            <AdminRoute>
              <NonWhatsappPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin-terms"
          element={
            <AdminRoute>
              <AdminTermsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/white-listing"
          element={
            <AdminRoute>
              <WhiteListingPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin-staff"
          element={
            <AdminRoute>
              <AdminStaffPage />
            </AdminRoute>
          }
        />
        <Route
          path="/campaign-config"
          element={
            <AdminRoute>
              <CampaignConfigPage />
            </AdminRoute>
          }
        />

        <Route path="*" element={<Navigate to={userInfo ? "/dashboard" : "/login"} replace />} />

      </Routes>
    </ThemeProvider>
  )
}

export default App
